import React from 'react';
const topics = ['HVAC', 'Real Estate', 'Airbnb', 'Garage Doors', 'Mobile Detailing', 'Videography', 'Drones', 'Psychology', 'Fashion', 'Marketing', 'Sales', 'Construction'];
export function GuestHighlights() {
  return <section className="bg-eofa-dark py-20 md:py-32" data-id="element-69">
      <div className="container mx-auto px-6 text-center" data-id="element-70">
        <h2 className="text-eofa-white font-heading font-black text-[28px] md:text-[40px] leading-[1.1] tracking-tighter mb-12" data-id="element-71">
          Real entrepreneurs. Real industries. Real stories.
        </h2>

        <div className="flex flex-wrap justify-center gap-4 mb-12 max-w-[800px] mx-auto" data-id="element-72">
          {topics.map(topic => <span key={topic} className="bg-transparent border border-eofa-yellow text-eofa-yellow text-sm font-medium rounded-full px-5 py-2.5" data-id="element-73">
              {topic}
            </span>)}
        </div>

        <p className="text-eofa-body text-base md:text-lg max-w-[600px] mx-auto" data-id="element-74">
          Every guest. Every industry. One mission. Show what real success
          actually looks like.
        </p>
      </div>
    </section>;
}